import React, { useState, useEffect, useContext } from "react";
import { Store } from "react-notifications-component";
import { Row, Col, Form, Card, Button, Table } from "react-bootstrap";
import { AutoComplete, Divider } from "rsuite";
import AdminChangePasswordModal from "./Modals/AdminChangePasswordModal";
import YesAndNoModal from "./Modals/YesAndNoModal";
import PermissionModal from "./Modals/PermissionModal";
import PermissionContext from "../../Store/permission-context";
import axios from "axios";

const ViewUser = () => {
  const PCtx = useContext(PermissionContext);
  const [AxiosError, setAxiosError] = useState("");
  const [showmodal, setshowmodal] = useState(false);
  const [showpermissionmodal, setshowpermissionmodal] = useState(false);
  const [showdeletemodal, setshowdeletemodal] = useState(false);
  const [ReloadUsers, setReloadUsers] = useState(false);
  const [AllStaff, setAllStaff] = useState([]);
  const [ThePermissions, setThePermissions] = useState([]);
  const [Username, setUsername] = useState("");
  const [Username2, setUsername2] = useState("");
  const [Fullname, setFullname] = useState("");
  const [Message, setMessage] = useState("");
  const [UserToDelete, setUserToDelete] = useState({});

  useEffect(() => {
    const getData = async () => {
      let AllUsers = await PCtx.connectAxios("getallusersdetails.php", "");
      setAllStaff(AllUsers);
    };
    getData();
  }, [ReloadUsers]);

  const cancelModal = () => {
    setshowmodal(false);
  };
  const cancelPermissionModal = () => {
    setshowpermissionmodal(false);
  };

  const cancelDeleteModal = () => {
    setshowdeletemodal(false);
  };

  const confirmDeleteUser = (Stf) => {
    setUserToDelete(Stf);
    setMessage("Are you sure you want to delete " + Stf.Fullname + " ?");
    setshowdeletemodal(true);
  };

  // useEffect(() => {
  //   if (UserToDelete != {}) {
  //     setshowdeletemodal(true);
  //   }
  // }, [UserToDelete]);

  const DeleteTheUser = async () => {
    let USD = { ...UserToDelete, usname: PCtx.Username };
    let Response = await PCtx.connectAxios("deletetheuser.php", USD);

    if (!Response.includes("Failure")) {
      setshowdeletemodal(false);
      setReloadUsers(!ReloadUsers);
      PCtx.displayAlert("SUCCESS", "Deleted Successfully", "success");
    }
  };

  const bringPasswordModal = (un) => {
    setUsername(un);
  };
  const bringPermissionModal = async (un, fn) => {
    let Permissions = await PCtx.connectAxios("getallpermissions.php", un);
    setFullname(fn);
    setThePermissions(Permissions);
    setUsername2(un);
  };
  //This brings out the password modal box
  useEffect(() => {
    if (Username != "") {
      setshowmodal(true);
    }
  }, [Username]);

  // This brings out the permission modal box
  useEffect(() => {
    if (ThePermissions.length > 0) {
      setshowpermissionmodal(true);
    }
  }, [ThePermissions]);

  return (
    <Row>
      <Col md={12} sm={12} xm={12}>
        <Card>
          <Card.Body>
            <h5
              className="text-center "
              style={{ color: "brown", fontFamily: "Times New Roman" }}
            >
              <Divider className="m-0">VIEW ALL USERS</Divider>
            </h5>
          </Card.Body>
        </Card>
      </Col>
      <Col md={12} sm={12} xm={12}>
        <Row>
          <Col md={12} sm={12} xm={12}>
            <Card>
              <Card.Header>ALL USERS</Card.Header>
              <Card.Body>
                <Table striped bordered responsive>
                  <thead>
                    <tr>
                      <td>SN</td>
                      <td>Username</td>
                      <td>Full Name</td>
                      <td>Date Registered</td>
                      <td>Last Login Date</td>
                      <td className="text-center">Permission</td>
                      <td className="text-center">Change Password</td>
                      <td className="text-center">Delete</td>
                    </tr>
                  </thead>
                  <tbody>
                    {AllStaff.map((stf, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{stf.Username}</td>
                        <td>{stf.Fullname}</td>
                        <td>{stf.DateRegistered}</td>
                        <td>{stf.LastLogin}</td>
                        <td className="text-center">
                          <Button
                            variant="success"
                            className="btn-small btn btn-xs"
                            onClick={() =>
                              bringPermissionModal(stf.Username, stf.Fullname)
                            }
                          >
                            View/Change
                          </Button>
                        </td>
                        <td className="text-center">
                          <Button
                            variant="success"
                            className="btn-small btn btn-xs"
                            onClick={() => bringPasswordModal(stf.Username)}
                          >
                            Change
                          </Button>
                        </td>
                        <td className="text-center">
                          <Button
                            variant="danger"
                            className="btn-small btn btn-xs"
                            onClick={() => confirmDeleteUser(stf)}
                          >
                            Delete
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Col>
      {showmodal && (
        <AdminChangePasswordModal
          showmodal={showmodal}
          Username={Username}
          cancelModal={cancelModal}
        />
      )}
      {showdeletemodal && (
        <YesAndNoModal
          showmodal={showdeletemodal}
          message={Message}
          NextEvent={cancelDeleteModal}
          modaltype="Error"
          deletereceipt={DeleteTheUser}
        />
      )}
      {showpermissionmodal && (
        <PermissionModal
          showpermissionmodal={showpermissionmodal}
          cancelModal={cancelPermissionModal}
          modaltype="Error"
          Username={Username2}
          Fullname={Fullname}
          ThePermissions={ThePermissions}
        />
      )}
    </Row>
  );
};

export default ViewUser;
